var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* eslint ember/no-classic-classes:"off" */
import Model from '@ember-data/model';
import { assert } from '@ember/debug';
import { isPresent } from '@ember/utils';
import { isArray } from '@ember/array';
import environment from '@square/environment-utils/environment';
import { v4 as uuid } from 'uuid';
import { get } from '@ember/object';
import { readOnly } from '@ember/object/computed';
function getPropertyValue(property) {
  return property?.getAllProperties ? property.getAllProperties() : property;
}
let EmberDataBaseModel = (_dec = readOnly('hasDirtyAttributes'), _class = class EmberDataBaseModel extends Model {
  constructor(...args) {
    super(...args);
    // In our existing code built on ember model, we rely on the isDirty property on the model
    // Ember Data does not have isDirty but instead has a property called hasDirtyAttributes
    // For new code, we should use hasDirtyAttributes directly
    _initializerDefineProperty(this, "isDirty", _descriptor, this);
  }
  getAllProperties() {
    const json = {};
    const attributes = [...this.constructor.attributes.keys()];
    const properties = {};
    attributes.forEach(attribute => {
      properties[attribute] = get(this, attribute);
    });
    const rootKey = this.constructor.rootKey;
    for (const key in properties) {
      const property = properties[key];
      if (isArray(property)) {
        json[key] = property.map(obj => getPropertyValue(obj));
      } else {
        json[key] = get(this, key);
      }
    }

    // TODO: support relationships
    if (rootKey) {
      const jsonRoot = {};
      jsonRoot[rootKey] = json;
      return jsonRoot;
    } else {
      return json;
    }
  }
  toJSON() {
    const serializer = this.store.serializerFor('-default');
    const snapshot = this._internalModel.createSnapshot();
    const options = {};
    return serializer.serialize(snapshot, options);
  }
  static createTestRecord(store, properties = {}) {
    assert('`model.createTestRecord()` should only be used in a test environment. Use `this.store.createRecord(...)` in production code.', environment().isTesting);
    assert('Please add `.reopenClass({ _modelNameForMigration: "model-name-goes-here"})` to the model class.', isPresent(this._modelNameForMigration));
    if (environment().isTesting) {
      return store.createRecord(this._modelNameForMigration, properties);
    }
    return null;
  }
  static deserializeTestRecord(store, properties) {
    assert('`model.deserializeTestRecord()` should only be used in a test environment. Use `this.store.createRecord(...)` in production code.', environment().isTesting);
    assert('Please add `.reopenClass({ _modelNameForMigration: "model-name-goes-here"})` to the model class.', isPresent(this._modelNameForMigration));
    return store.push(store.normalize(this._modelNameForMigration, {
      id: uuid().toString(),
      ...properties
    }));
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "isDirty", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { EmberDataBaseModel as default };